<h2 class="title">Edit news item: '{{ item.id }}'</h2>

<mat-dialog-content>
  <div class="form-container">
    <form [formGroup]="newsItemForm" (ngSubmit)="editNewsItem()">
      <mat-form-field appearance="fill">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Title" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>ExpirationDate</mat-label>
        <input matInput [matDatepicker]="dobpicker1" min="2000-01-01" formControlName="expirationDate" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="dobpicker1"></mat-datepicker-toggle>
        <mat-datepicker #dobpicker1></mat-datepicker>
      </mat-form-field>
      <mat-label>Content</mat-label>
      <div class="NgxEditor__Wrapper">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="content" [placeholder]="'Type here...'"></ngx-editor>
      </div>

      <br />
      <mat-checkbox formControlName="forInternal">Internal</mat-checkbox>
      <mat-checkbox formControlName="forCenter">Center</mat-checkbox>
      <mat-checkbox formControlName="forLab">Lab</mat-checkbox>

      <button mat-raised-button color="primary" type="submit" style="float: right">Edit news item</button>
    </form>
  </div>
</mat-dialog-content>
